import { husselPages, softwarePages, blogPages, mainPages, relatedPages, type SitePage } from "@/lib/site-pages";

const Col = ({ title, items }: { title: string; items: SitePage[] }) => (
  <div>
    <h3 className="text-sm font-semibold text-foreground mb-3">{title}</h3>
    <ul className="space-y-2">
      {items.map((p) => (
        <li key={p.href}>
          <a href={p.href} className="text-sm text-muted-foreground hover:text-primary transition-colors">
            {p.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

/** Overzicht van alle publieke pagina's als echte links (voor bezoekers én zoekmachines). */
export const SiteLinksDirectory = () => (
  <nav aria-label="Alle pagina's" className="container mx-auto max-w-6xl px-3 py-8 grid grid-cols-2 md:grid-cols-4 gap-6 text-left">
    <Col title="Husselen & tossen" items={husselPages} />
    <Col title="Software & app" items={softwarePages} />
    <Col title="Blog" items={blogPages} />
    <Col title="De Hussel App" items={mainPages} />
  </nav>
);

/** "Lees ook"-blok met gerelateerde pagina's. */
export const RelatedPages = ({ currentPath }: { currentPath: string }) => {
  const items = relatedPages(currentPath);
  return (
    <section className="py-10 px-3">
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-6">Lees ook</h2>
        <ul className="grid sm:grid-cols-2 gap-3">
          {items.map((p) => (
            <li key={p.href}>
              <a href={p.href} className="block rounded-lg border border-border bg-card p-4 text-foreground hover:border-primary hover:text-primary transition-colors">
                {p.label} →
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
